// extracted by mini-css-extract-plugin
export var active = "Plants-module--active--90938";
export var core = "Plants-module--core--fcaff";
export var en = "Plants-module--en--8f601";
export var es = "Plants-module--es--05f8f";
export var pt = "Plants-module--pt--ea7ae";